import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PresentationsState } from './presentations.reducer';

export const selectPresentationsState = createFeatureSelector<PresentationsState>('presentations');

export const selectPresentations = createSelector(
  selectPresentationsState,
  (state) => state.presentations,
);

export const selectPresentationsLoading = createSelector(
  selectPresentationsState,
  (state) => state.isLoading,
);

export const selectPresentationsError = createSelector(
  selectPresentationsState,
  (state) => state.error,
);

export const selectPresentationsPage = createSelector(
  selectPresentationsState,
  (state) => state.page,
);

export const selectPresentationsTotal = createSelector(
  selectPresentationsState,
  (state) => state.total,
);
